export default "__VITE_ASSET__wvTNwglp__"